var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6399 25.0001H26.3466C27.3732 25.0001 28.0132 23.8934 27.5066 23.0001L15.1466 1.66673C15.0305 1.46332 14.8626 1.29423 14.6601 1.17662C14.4575 1.05902 14.2275 0.99707 13.9932 0.99707C13.759 0.99707 13.529 1.05902 13.3264 1.17662C13.1239 1.29423 12.956 1.46332 12.8399 1.66673L0.479897 23.0001C-0.0267701 23.8934 0.61323 25.0001 1.6399 25.0001ZM15.3332 21.0001H12.6666V18.3334H15.3332V21.0001ZM13.9999 15.6667C13.2666 15.6667 12.6666 15.0667 12.6666 14.3334V11.6667C12.6666 10.9334 13.2666 10.3334 13.9999 10.3334C14.7332 10.3334 15.3332 10.9334 15.3332 11.6667V14.3334C15.3332 15.0667 14.7332 15.6667 13.9999 15.6667Z",
    fill: "#E6B800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.594e2364c646b103f69293988a1955ef.svg";
export { ForwardRef as ReactComponent };